import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'rc-progress/assets/index.css';
import { Line } from 'rc-progress';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MonetizationOnOutlined from '@material-ui/icons/MonetizationOnOutlined';
import moment from 'moment'
import { fetchToday } from '../utils/quoteOfTheDay';

export class Bulletin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companySalesThisYear: {
        today: 0,
        week: 0,
        month: 0,
        year: 0
      },
      companySalesLastYear: {
        today: 0,
        week: 0,
        month: 0,
        year: 0
      },
      yourSalesThisYear: {
        today: 0,
        yesterday: 0,
        week: 0,
        month: 0,
        quarter: 0,
        year: 0
      },
      yourSalesLastYear: {
        today: 0,
        yesterday: 0,
        week: 0,
        month: 0,
        quarter: 0,
        year: 0
      },
      quote: "Many people fail in life, not for lack of ability or brains or even courage but simply because they have never organized their energies around a goal.",
      // The fallback, not the only one any more - componentDidMount replaces
      // this with api/QuoteOfTheDay/Today. QuoteOfTheDayController holds the
      // same pair for the case where the pool is empty.
      quoteAuthor: "Elbert Hubbard",
    };
  }

  componentDidMount() {
    // Load bulletin.
    this.getBulletin();
    this.getQuoteOfTheDay();
  }

  getQuoteOfTheDay = () => {
    return fetchToday().then((quote) => {
      // null means no token, a rejected one, or an unreachable server. The
      // hardcoded pair is still on screen in that case, which is the point.
      if (quote && quote.text) {
        this.setState({ quote: quote.text, quoteAuthor: quote.author || '' });
      }
    });
  };

  getBulletin = () => {
    const token = localStorage.token;
    if (token) {
      return fetch("api/bulletin/GetUserGoals", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': `Bearer ${token}`
        }
      })
        .then(resp => resp.json())
        .then(data => {
          var bulletin = {
            companySalesThisYear: {
              today: data['companyDay'],
              week: data['companyWeek'],
              month: data['companyMonth'],
              year: data['companyYear']
            },
            companySalesLastYear: {
              today: data['lastCompanyDay'],
              week: data['lastCompanyWeek'],
              month: data['lastCompanyMonth'],
              year: data['lastCompanyYear']
            },
            yourSalesThisYear: {
              today: data['personalToday'],
              yesterday: data['personalYesterday'],
              week: data['personalWeek'],
              month: data['personalMonth'],
              quarter: data['personalQuarter'],
              year: data['personalYear']
            },
            yourSalesLastYear: {
              today: data['lastPersonalToday'],
              yesterday: data['lastPersonalYesterday'],
              week: data['lastPersonalWeek'],
              month: data['lastPersonalMonth'],
              quarter: data['lastPersonalQuarter'],
              year: data['lastPersonalYear']
            }
          };
          this.setState(bulletin);
        });
    }
  }

  getCurrentDateTime = () => {
    var today = new Date();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    var day = weekday[today.getDay()];

    var months = new Array(12);
    months[0] = "January";
    months[1] = "February";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";
    var month = months[today.getMonth()];

    return day + ' ' + month + ' ' + today.getDate() + ', ' + today.getFullYear();
  };

  getDaysRemainingInWeek = () => {
    const endOfWeek = moment().endOf('week');
    const now = moment();
    const daysUntilEndOfWeek = endOfWeek.diff(now, 'days');
    if (daysUntilEndOfWeek === 1) {
      return "There is 1 day left in the week";
    }
    return "There are " + daysUntilEndOfWeek + " days left in the week";
  }

  getDaysRemainingInMonth = () => {
    const endOfMonth = moment().endOf('month');
    const now = moment();
    const daysUntilEndOfMonth = endOfMonth.diff(now, 'days');
    if (daysUntilEndOfMonth === 1) {
      return "There is 1 day left in the month";
    }
    return "There are " + daysUntilEndOfMonth + " days left in the month";
  }

  getDaysRemainingInQuarter = () => {
    const endOfQuarter = moment().endOf('quarter');
    const now = moment();
    const daysUntilEndOfQuarter = endOfQuarter.diff(now, 'days');
    if (daysUntilEndOfQuarter === 1) {
      return "There is 1 day left in the quarter";
    }
    return "There are " + daysUntilEndOfQuarter + " days left in the quarter";
  }

  getDaysRemainingInYear = () => {
    const endOfMonth = moment().endOf('year');
    const now = moment();
    const daysUntilEndOfMonth = endOfMonth.diff(now, 'days');
    if (daysUntilEndOfMonth === 1) {
      return "There is 1 day left in the year";
    }
    return "There are " + daysUntilEndOfMonth + " days left in the year";
  }

  getTimeRemaining = (endtime) => {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  render() {
    let bulletin;
    let todayColor;
    let weekColor;
    let monthColor;
    let yearColor;
    let yourTodayColor;
    let yourYesterdayColor;
    let yourWeekColor;
    let yourMonthColor;
    let yourQuarterColor;
    let yourYearColor;

    // company sales
    const todayGoal = 15000;
    const weekGoal = 75000;
    const monthGoal = 315000;
    const yearGoal = 3800000;

    var todayPercent = (this.state.companySalesThisYear.today / todayGoal) * 100;
    let weekPercent = (this.state.companySalesThisYear.week / weekGoal) * 100;
    let monthPercent = (this.state.companySalesThisYear.month / monthGoal) * 100;
    let yearPercent = (this.state.companySalesThisYear.year / yearGoal) * 100;

    if (todayPercent >= 0 && todayPercent <= 40) {
      todayColor = '#fc9d03';
    } else if (todayPercent >= 41 && todayPercent <= 80) {
      todayColor = '#1bbf6c';
    } else if (todayPercent >= 81 && todayPercent <= 99) {
      todayColor = '#1260de';
    } else if (todayPercent >= 100) {
      todayColor = '#f5aec5';
    }

    if (weekPercent >= 0 && weekPercent <= 40) {
      weekColor = '#fc9d03';
    } else if (weekPercent >= 41 && weekPercent <= 80) {
      weekColor = '#1bbf6c';
    } else if (weekPercent >= 81 && weekPercent <= 99) {
      weekColor = '#1260de';
    } else if (weekPercent >= 100) {
      weekColor = '#f5aec5';
    }

    if (monthPercent >= 0 && monthPercent <= 40) {
      monthColor = '#fc9d03';
    } else if (monthPercent >= 41 && monthPercent <= 80) {
      monthColor = '#1bbf6c';
    } else if (monthPercent >= 81 && monthPercent <= 99) {
      monthColor = '#1260de';
    } else if (monthPercent >= 100) {
      monthColor = '#f5aec5';
    }

    if (yearPercent >= 0 && yearPercent <= 40) {
      yearColor = '#fc9d03';
    } else if (yearPercent >= 41 && yearPercent <= 80) {
      yearColor = '#1bbf6c';
    } else if (yearPercent >= 81 && yearPercent <= 99) {
      yearColor = '#1260de';
    } else if (yearPercent >= 100) {
      yearColor = '#f5aec5';
    }

    //var todayLeft = (todayGoal - this.state.companySalesThisYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    //var weekLeft = (weekGoal - this.state.companySalesThisYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    //var monthLeft = (monthGoal - this.state.companySalesThisYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    //var yearLeft = (yearGoal - this.state.companySalesThisYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

    // your sales
    var yourTodayPercent = (this.state.yourSalesThisYear.today / 1000) * 100;
    var yourYesterdayPercent = (this.state.yourSalesThisYear.yesterday / 1000) * 100;
    let yourWeekPercent = (this.state.yourSalesThisYear.week / 5000) * 100;
    let yourMonthPercent = (this.state.yourSalesThisYear.month / 21500) * 100;
    let yourQuarterPercent = (this.state.yourSalesThisYear.quarter / 64500) * 100;
    let yourYearPercent = (this.state.yourSalesThisYear.year / 258000) * 100;

    if (yourTodayPercent >= 0 && yourTodayPercent <= 40) {
      yourTodayColor = '#fc9d03';
    } else if (yourTodayPercent >= 41 && yourTodayPercent <= 80) {
      yourTodayColor = '#1bbf6c';
    } else if (yourTodayPercent >= 81 && yourTodayPercent <= 99) {
      yourTodayColor = '#1260de';
    } else if (yourTodayPercent >= 100) {
      yourTodayColor = '#f5aec5';
    }

    if (yourYesterdayPercent >= 0 && yourYesterdayPercent <= 40) {
      yourYesterdayColor = '#fc9d03';
    } else if (yourYesterdayPercent >= 41 && yourYesterdayPercent <= 80) {
      yourYesterdayColor = '#1bbf6c';
    } else if (yourYesterdayPercent >= 81 && yourYesterdayPercent <= 99) {
      yourYesterdayColor = '#1260de';
    } else if (yourYesterdayPercent >= 100) {
      yourYesterdayColor = '#f5aec5';
    }

    if (yourWeekPercent >= 0 && yourWeekPercent <= 40) {
      yourWeekColor = '#fc9d03';
    } else if (yourWeekPercent >= 41 && yourWeekPercent <= 80) {
      yourWeekColor = '#1bbf6c';
    } else if (yourWeekPercent >= 81 && yourWeekPercent <= 99) {
      yourWeekColor = '#1260de';
    } else if (yourWeekPercent >= 100) {
      yourWeekColor = '#f5aec5';
    }

    if (yourMonthPercent >= 0 && yourMonthPercent <= 40) {
      yourMonthColor = '#fc9d03';
    } else if (yourMonthPercent >= 41 && yourMonthPercent <= 80) {
      yourMonthColor = '#1bbf6c';
    } else if (yourMonthPercent >= 81 && yourMonthPercent <= 99) {
      yourMonthColor = '#1260de';
    } else if (yourMonthPercent >= 100) {
      yourMonthColor = '#f5aec5';
    }

    if (yourQuarterPercent >= 0 && yourQuarterPercent <= 40) {
      yourQuarterColor = '#fc9d03';
    } else if (yourQuarterPercent >= 41 && yourQuarterPercent <= 80) {
      yourQuarterColor = '#1bbf6c';
    } else if (yourQuarterPercent >= 81 && yourQuarterPercent <= 99) {
      yourQuarterColor = '#1260de';
    } else if (yourQuarterPercent >= 100) {
      yourQuarterColor = '#f5aec5';
    }

    if (yourYearPercent >= 0 && yourYearPercent <= 40) {
      yourYearColor = '#fc9d03';
    } else if (yourYearPercent >= 41 && yourYearPercent <= 80) {
      yourYearColor = '#1bbf6c';
    } else if (yourYearPercent >= 81 && yourYearPercent <= 99) {
      yourYearColor = '#1260de';
    } else if (yourYearPercent >= 100) {
      yourYearColor = '#f5aec5';
    }
    this.props.members.forEach(member => {
        if (member.roles === "S") console.log(member);
    });
    if (this.props.profile.roles !== null && this.props.profile.roles.includes("S")) { // Only place where INDIVIDUAL sales where appear (ie member's roles === "S")
      bulletin =
        <Grid container spacing={1} justifyContent="center" style={{ paddingTop: '70px' }}>
        
          {/*your sales*/}
          <Grid item xs={12} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ paddingBottom: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Your Sales</Typography>
                </Grid>
                <Grid container item xs={4} spacing={0} style={{}}> {/*progress bars*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Progress</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourTodayPercent} strokeWidth="10" trailWidth="10" strokeColor={yourTodayColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourTodayPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourYesterdayPercent} strokeWidth="10" trailWidth="10" strokeColor={yourYesterdayColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourYesterdayPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourWeekPercent} strokeWidth="10" trailWidth="10" strokeColor={yourWeekColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourWeekPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourMonthPercent} strokeWidth="10" trailWidth="10" strokeColor={yourMonthColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourMonthPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourQuarterPercent} strokeWidth="10" trailWidth="10" strokeColor={yourQuarterColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourQuarterPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yourYearPercent} strokeWidth="10" trailWidth="10" strokeColor={yourYearColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-25px', fontWeight: 'bold', color: 'white' }}>{Math.round(yourYearPercent)}%</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '35px' }}> {/*goal*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Goal</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$1,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$1,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$5,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$21,500</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$64,500</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '45px' }}>$258,000</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0}> {/*time frame*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Time Frame</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Today</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Yesterday</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Week to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Month to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Quarter to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ paddingLeft: '45px' }}>Year to Date</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*this year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>This Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.yesterday).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.quarter).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '55px' }}>${(this.state.yourSalesThisYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '8px' }}> {/*last year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Last Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.yesterday).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.quarter).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '55px' }}>${(this.state.yourSalesLastYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*company sales */}
          <Grid item xs={6} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '5px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ paddingBottom: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Company Sales</Typography>
                </Grid>
                <Grid container item xs={4} spacing={0} style={{}}> {/*progress bars*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Progress</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={todayPercent} strokeWidth="10" trailWidth="10" strokeColor={todayColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(todayPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={weekPercent} strokeWidth="10" trailWidth="10" strokeColor={weekColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(weekPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={monthPercent} strokeWidth="10" trailWidth="10" strokeColor={monthColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(monthPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yearPercent} strokeWidth="10" trailWidth="10" strokeColor={yearColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(yearPercent)}%</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*goal*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Goal</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '8px' }}>$15,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '8px' }}>$75,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '8px' }}>$315,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '8px' }}>$3,800,000</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0}> {/*time frame*/}
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Time Frame</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Today</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Week to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Month to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Year to Date</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*this year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>This Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '8px' }}>${(this.state.companySalesThisYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '8px' }}>${(this.state.companySalesThisYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '8px' }}>${(this.state.companySalesThisYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '8px' }}>${(this.state.companySalesThisYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '8px' }}> {/*last year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Last Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '10px' }}>${(this.state.companySalesLastYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '10px' }}>${(this.state.companySalesLastYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '10px' }}>${(this.state.companySalesLastYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '10px' }}>${(this.state.companySalesLastYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*quote management*/}
          <Grid item xs={6} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ paddingBottom: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Quote Management</Typography>
                </Grid>
                <Grid container item xs={3} spacing={0} style={{}}> {/*progress bars*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Progress</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={0} strokeWidth="10" trailWidth="10" strokeColor={todayColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-16px', fontWeight: 'bold', color: 'white' }}>{0}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={0} strokeWidth="10" trailWidth="10" strokeColor={weekColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-16px', fontWeight: 'bold', color: 'white' }}>{0}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={0} strokeWidth="10" trailWidth="10" strokeColor={monthColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-16px', fontWeight: 'bold', color: 'white' }}>{0}%</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*goal*/}
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Goal</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>0%</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>0%</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>$0</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={5} spacing={0}> {/*category*/}
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Category</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>% of Total Inquirers Quoted</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>% of Total Quotes Closed</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Average Order Amount</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*current*/}
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Current</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold' }}>0%</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold' }}>0%</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold' }}>$0</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*bonuses*/}
          <Grid item xs={4} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ padding: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" color="inherit" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    Bonuses
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: '10px' }}>
                  <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}><MonetizationOnOutlined />$20 Bonus: $75,000 this week</Typography>
                  <Line percent={weekPercent} strokeWidth="10" trailWidth="10" strokeColor={weekColor} style={{}} />
                  <Typography align="center" variant="h6" style={{ marginTop: '-22px', fontWeight: 'bold', color: 'white' }}>{Math.round(weekPercent)}%</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}><MonetizationOnOutlined />$100 Bonus: $315,000 this month</Typography>
                  <Line percent={monthPercent} strokeWidth="10" trailWidth="10" strokeColor={monthColor} style={{}} />
                  <Typography align="center" variant="h6" style={{ marginTop: '-22px', fontWeight: 'bold', color: 'white' }}>{Math.round(monthPercent)}%</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*quote*/}
          <Grid item xs={4} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '5px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ padding: '5px' }}>
                <Grid item xs={12}>
                  <Typography color="inherit" align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Quote of the Day</Typography>
                  <Typography variant="h6" color="inherit" align="center" style={{}}>{this.state.quote}</Typography>
                  <Typography variant="h6" color="inherit" align="right" style={{ fontWeight: 'bold' }}>{this.state.quoteAuthor}</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*business days*/}
          <Grid item xs={4} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Typography color="inherit" align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Business Days Left</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInWeek()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInMonth()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInQuarter()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInYear()}</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

        </Grid>;
    } else {
      bulletin =
        <Grid container spacing={0} justifyContent="center" style={{ paddingTop: '70px' }}>

        {/*company sales */}
          <Grid item xs={8} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '5px' }}>
          <Card>
              <Grid container item xs={12} spacing={0} style={{ paddingBottom: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Company Sales</Typography>
                </Grid>
                <Grid container item xs={4} spacing={0} style={{}}> {/*progress bars*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Progress</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={todayPercent} strokeWidth="10" trailWidth="10" strokeColor={todayColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(todayPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={weekPercent} strokeWidth="10" trailWidth="10" strokeColor={weekColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(weekPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={monthPercent} strokeWidth="10" trailWidth="10" strokeColor={monthColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(monthPercent)}%</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '5px' }}>
                    <Line percent={yearPercent} strokeWidth="10" trailWidth="10" strokeColor={yearColor} style={{}} />
                    <Typography align="center" variant="h6" style={{ marginTop: '-19px', fontWeight: 'bold', color: 'white' }}>{Math.round(yearPercent)}%</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*goal*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Goal</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>$15,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>$75,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>$315,000</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>$3,800,000</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0}> {/*time frame*/}
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Time Frame</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Today</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Week to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Month to Date</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{}}>Year to Date</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '10px' }}> {/*this year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>This Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '12px' }}>${(this.state.companySalesThisYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '12px' }}>${(this.state.companySalesThisYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '12px' }}>${(this.state.companySalesThisYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ fontWeight: 'bold', paddingRight: '12px' }}>${(this.state.companySalesThisYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={2} spacing={0} style={{ paddingLeft: '8px' }}> {/*last year*/}
                  <Grid item xs={12}>
                    <Typography align="center" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Last Year</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>${(this.state.companySalesLastYear.today).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>${(this.state.companySalesLastYear.week).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>${(this.state.companySalesLastYear.month).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography align="right" variant="h6" style={{ paddingRight: '12px' }}>${(this.state.companySalesLastYear.year).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

        {/*bonuses*/}
          <Grid item xs={4} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ padding: '5px' }}>
                <Grid item xs={12}>
                  <Typography align="center" color="inherit" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    Bonuses
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: '10px' }}>
                  <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}><MonetizationOnOutlined />$20 Bonus: $75,000 this week</Typography>
                  <Line percent={weekPercent} strokeWidth="10" trailWidth="10" strokeColor={weekColor} style={{}} />
                  <Typography align="center" variant="h6" style={{ marginTop: '-22px', fontWeight: 'bold', color: 'white' }}>{Math.round(weekPercent)}%</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography align="left" variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}><MonetizationOnOutlined />$100 Bonus: $315,000 this month</Typography>
                  <Line percent={monthPercent} strokeWidth="10" trailWidth="10" strokeColor={monthColor} style={{}} />
                  <Typography align="center" variant="h6" style={{ marginTop: '-22px', fontWeight: 'bold', color: 'white' }}>{Math.round(monthPercent)}%</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

        {/*quote*/}
          <Grid item xs={8} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px', paddingRight: '5px' }}>
            <Card>
              <Grid container item xs={12} spacing={0} style={{ padding: '5px' }}>
                <Grid item xs={12}>
                  <Typography color="inherit" align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Quote of the Day</Typography>
                  <Typography variant="h6" color="inherit" align="center" style={{}}>{this.state.quote}</Typography>
                  <Typography variant="h6" color="inherit" align="right" style={{ fontWeight: 'bold' }}>{this.state.quoteAuthor}</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>

        {/*business days*/}
          <Grid item xs={4} style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: '5px', paddingRight: '10px' }}>
            <Card>
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Typography color="inherit" align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Business Days Left</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInWeek()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInMonth()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInQuarter()}</Typography>
                  <Typography color="inherit" align="center" style={{ padding: '5px', fontSize: '14px' }}>{this.getDaysRemainingInYear()}</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        
        </Grid>;
    }

    return (
      <div style={{ backgroundColor: '#f5f5f5', height: '100%', paddingRight: '4px'}}>
        <AppBar position="fixed" style={{ borderBottom: 'solid 1px', borderColor: '#dedede', backgroundColor: '#3f51b5', width: '100%' }}>
          <Toolbar>
            <Grid container spacing={0}>
              <Grid item xs={6}>
                <Typography variant="h5" color="inherit" style={{ color: 'white' }}>
                  Hello, {this.props.profile.firstName}!
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="inherit" align="right" style={{ color: 'white' }}>
                  {this.getCurrentDateTime()}
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        {bulletin}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
  };
}

export default connect(mapStateToProps, null)(Bulletin);


// WEBPACK FOOTER //
// ./src/components/Bulletin.js